/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscaleinnermotorweak4Inputs */



/**
* | output |
* | --- |
* | "Using emotions as a source of motivation can be hard for you — understanding your own feelings will make it easier to find energy to act." |
*
* @param {Eisubscaleinnermotorweak4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscaleinnermotorweak4 = /** @type {((inputs?: Eisubscaleinnermotorweak4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscaleinnermotorweak4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Using emotions as a source of motivation can be hard for you — understanding your own feelings will make it easier to find energy to act.")
	if (locale === "es") return /** @type {LocalizedString} */ ("A veces te cuesta usar las emociones como fuente de motivación — entender tus propios sentimientos te ayudará a encontrar energía para actuar.")
	return /** @type {LocalizedString} */ ("Тебе бывает сложно использовать эмоции как источник мотивации — понимание своих чувств поможет легче находить энергию для действий.")
});
export { eisubscaleinnermotorweak4 as "eiSubscaleInnerMotorWeak" }